define("media/components/media/manage-labels", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/object/computed", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "later/lib/filter-by-fields", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _computed, _service, _utils, _component2, _tracking, _emberConcurrency, _filterByFields, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/object/computed",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"later/lib/filter-by-fields",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <Shared::Modal @close={{@closeManageLabelsModal}} as |modal|>
    <modal.card @portrait={{true}}>
      {{!  Header }}
      <modal.card-header>
        <p class="o--modalHeader__title">
          {{t "media_library.labels.manage.title"}}
          <span class="u--text--sm u--text--light u--m__l__xs">
            {{t "media_library.labels.manage.total"}}
            {{this.labelCount}}
          </span>
        </p>
      </modal.card-header>
      <hr class="u--m__0" />
  
      {{!  Filter / Search }}
      <modal.card-body>
        <div class="u--row">
  
          <div class="u--col__7">
            <div class="o--btnGroup">
  
              <Shared::Ui::Button
                @class={{if this.isLabelNameSorting "is--active"}}
                @variant="outline"
                class="o--btnDrop eLB--labelSortName--toggle"
              >
                <span class="u--text--base">{{t "media_library.labels.manage.sorting.name"}}</span>
                {{#if this.isLabelNameSorting}}
                  <span class="o--btnDrop__value">
                    {{#if this.isLabelSortingAsc}}
                      ({{t "media_library.labels.manage.sorting.a_z_label"}})
                    {{else}}
                      ({{t "media_library.labels.manage.sorting.z_a_label"}})
                    {{/if}}
                  </span>
                {{/if}}
  
                {{svg-jar "caret-down" class="o--icon o--btnDrop__icon"}}
                <Shared::Ui::EmberDrop
                  @constrainToScrollParent={{true}}
                  @constrainToWindow={{true}}
                  @contentSelector=".eLB--labelSortName--drop"
                  @position="bottom left"
                  @target=".eLB--labelSortName--toggle"
                >
  
                  <div class="o--dropWrapper--xs eLB--labelSortName--drop">
                    <div class="o--dropBody--scroll">
                      <ul class="o--dropBody__list">
                        <li class="o--dropBody__item">
                          <Shared::Ui::Button
                            @class="o--dropBody__link u--ellipsis {{if this.isLabelNameAsc 'is--active'}}"
                            @onClick={{fn this.setSort "canonicalTagName" "asc"}}
                            @text={{t "media_library.labels.manage.sorting.a_z_option"}}
                            @variant="unstyled"
                          />
                        </li>
                        <li class="o--dropBody__item">
                          <Shared::Ui::Button
                            @class="o--dropBody__link u--ellipsis {{if this.isLabelNameDesc 'is--active'}}"
                            @onClick={{fn this.setSort "canonicalTagName" "desc"}}
                            @text={{t "media_library.labels.manage.sorting.z_a_option"}}
                            @variant="unstyled"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
  
                </Shared::Ui::EmberDrop>
              </Shared::Ui::Button>
  
              <Shared::Ui::Button
                @class={{if this.isLabelTaggedCountSorting "is--active"}}
                @variant="outline"
                class="o--btnDrop eLB--labelSortUsage--toggle"
              >
                <span class="u--text--base">{{t "media_library.labels.manage.sorting.tagged_count"}}</span>
                {{#if this.isLabelTaggedCountSorting}}
                  <span class="o--btnDrop__value">
                    {{#if this.isLabelSortingAsc}}
                      ({{t "media_library.labels.manage.sorting.least_to_most"}})
                    {{else}}
                      ({{t "media_library.labels.manage.sorting.most_to_least"}})
                    {{/if}}
                  </span>
                {{/if}}
                {{svg-jar "caret-down" class="o--icon o--btnDrop__icon"}}
                <Shared::Ui::EmberDrop
                  @constrainToScrollParent={{true}}
                  @constrainToWindow={{true}}
                  @contentSelector=".eLB--labelSortUsage--drop"
                  @position="bottom left"
                  @target=".eLB--labelSortUsage--toggle"
                >
                  <div class="o--dropWrapper--sm eLB--labelSortUsage--drop">
                    <div class="o--dropBody--scroll">
                      <ul class="o--dropBody__list">
                        <li class="o--dropBody__item">
                          <Shared::Ui::Button
                            @class="o--dropBody__link u--ellipsis {{if this.isLabelTaggedCountDesc 'is--active'}}"
                            @onClick={{fn this.setSort "taggedCount" "desc"}}
                            @text={{t "media_library.labels.manage.sorting.most_to_least"}}
                            @variant="unstyled"
                          />
                        </li>
                        <li class="o--dropBody__item">
                          <Shared::Ui::Button
                            @class="o--dropBody__link u--ellipsis {{if this.isLabelTaggedCountAsc 'is--active'}}"
                            @onClick={{fn this.setSort "taggedCount" "asc"}}
                            @text={{t "media_library.labels.manage.sorting.least_to_most"}}
                            @variant="unstyled"
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </Shared::Ui::EmberDrop>
              </Shared::Ui::Button>
  
            </div>
          </div>
  
          <div class="u--col__5">
            <div class="o--formWrapper u--m__b__0">
              <div class="o--inputAction u--p__r__xs">
                {{svg-jar "search" class="o--icon o--inputAction__icon--left"}}
                <Input
                  @type="search"
                  @value={{this.labelSearchString}}
                  class="o--inputAction__input u--p__tb__sm qa--mediaLib_manageLabel_search"
                  placeholder={{t "media_items.labels.search_labels"}}
                />
                {{#if this.isSearchingLabels}}
                  <span {{on "click" this.clearLabelSearch}}>
                    {{svg-jar "close" class="o--icon o--inputAction__icon--right u--fadeIn--right"}}
                  </span>
                {{/if}}
              </div>
            </div>
          </div>
  
        </div>
      </modal.card-body>
      <hr class="u--m__0" />
  
      {{!  Label List / Add Label }}
  
      <modal.card-body class="has--scroll u--p__0 eLB--manage__scrollContainer" {{perfect-scroll}}>
  
        <div class="u--p__lr__lg u--m__tb__md">
  
          {{!  Add Label }}
          <div class="o--formWrapper">
            <div class="o--inputAction--light u--p__l">
              <Input
                @enter={{this.addNewLabel}}
                @type="text"
                @value={{this.newLabel}}
                class="o--inputAction__input qa--mediaLib_labelAdd_inputbx"
                placeholder={{t "media_items.labels.add_new_label"}}
              />
              <span {{on "click" this.addNewLabel}}>
                {{svg-jar
                  "add-circle"
                  class="o--icon o--inputAction__icon--right u--text--hl u--text--lg qa--mediaLib_labelAdd_btn"
                }}
              </span>
            </div>
          </div>
  
          {{#each this.filteredSortedLabels as |filteredSortedLabel|}}
            <div class="cLB--filter__item">
              <div class="cLB--label cLB--label--noPointer u--ellipsis">
                <span>{{filteredSortedLabel.canonicalTagName}}</span>
                <span class="cLB--label__counter has--icon">{{filteredSortedLabel.taggedCount}}</span>
                <span {{on "click" (perform this.deleteLabel filteredSortedLabel)}}>
                  {{svg-jar "trash" class="o--icon--sm cLB--label__icon--delete qa--mediaLib_labelDel_btn"}}
                </span>
              </div>
            </div>
          {{/each}}
  
        </div>
      </modal.card-body>
  
      {{!  Footer }}
      <modal.card-footer>
        <Shared::Ui::Button
          @onClick={{@closeManageLabelsModal}}
          @text={{t "shared_words.done"}}
          @variant="outline"
          class="u--float--right qa--mediaLib_labelDone_btn"
        />
      </modal.card-footer>
  
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "t1f+VHC1",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[30,1]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,2,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\"],[1,\"    \"],[8,[30,2,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,2],[14,0,\"o--modalHeader__title\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"media_library.labels.manage.title\"],null]],[1,\"\\n        \"],[10,1],[14,0,\"u--text--sm u--text--light u--m__l__xs\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"media_library.labels.manage.total\"],null]],[1,\"\\n          \"],[1,[30,0,[\"labelCount\"]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n\\n\"],[1,\"    \"],[8,[30,2,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--row\"],[12],[1,\"\\n\\n        \"],[10,0],[14,0,\"u--col__7\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--btnGroup\"],[12],[1,\"\\n\\n            \"],[8,[39,2],[[24,0,\"o--btnDrop eLB--labelSortName--toggle\"]],[[\"@class\",\"@variant\"],[[52,[30,0,[\"isLabelNameSorting\"]],\"is--active\"],\"outline\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,1],[14,0,\"u--text--base\"],[12],[1,[28,[35,1],[\"media_library.labels.manage.sorting.name\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"isLabelNameSorting\"]],[[[1,\"                \"],[10,1],[14,0,\"o--btnDrop__value\"],[12],[1,\"\\n\"],[41,[30,0,[\"isLabelSortingAsc\"]],[[[1,\"                    (\"],[1,[28,[35,1],[\"media_library.labels.manage.sorting.a_z_label\"],null]],[1,\")\\n\"]],[]],[[[1,\"                    (\"],[1,[28,[35,1],[\"media_library.labels.manage.sorting.z_a_label\"],null]],[1,\")\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n              \"],[1,[28,[35,4],[\"caret-down\"],[[\"class\"],[\"o--icon o--btnDrop__icon\"]]]],[1,\"\\n              \"],[8,[39,5],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@position\",\"@target\"],[true,true,\".eLB--labelSortName--drop\",\"bottom left\",\".eLB--labelSortName--toggle\"]],[[\"default\"],[[[[1,\"\\n\\n                \"],[10,0],[14,0,\"o--dropWrapper--xs eLB--labelSortName--drop\"],[12],[1,\"\\n                  \"],[10,0],[14,0,\"o--dropBody--scroll\"],[12],[1,\"\\n                    \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n                      \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n                        \"],[8,[39,2],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[29,[\"o--dropBody__link u--ellipsis \",[52,[30,0,[\"isLabelNameAsc\"]],\"is--active\"]]],[28,[37,6],[[30,0,[\"setSort\"]],\"canonicalTagName\",\"asc\"],null],[28,[37,1],[\"media_library.labels.manage.sorting.a_z_option\"],null],\"unstyled\"]],null],[1,\"\\n                      \"],[13],[1,\"\\n                      \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n                        \"],[8,[39,2],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[29,[\"o--dropBody__link u--ellipsis \",[52,[30,0,[\"isLabelNameDesc\"]],\"is--active\"]]],[28,[37,6],[[30,0,[\"setSort\"]],\"canonicalTagName\",\"desc\"],null],[28,[37,1],[\"media_library.labels.manage.sorting.z_a_option\"],null],\"unstyled\"]],null],[1,\"\\n                      \"],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n\\n              \"]],[]]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\\n            \"],[8,[39,2],[[24,0,\"o--btnDrop eLB--labelSortUsage--toggle\"]],[[\"@class\",\"@variant\"],[[52,[30,0,[\"isLabelTaggedCountSorting\"]],\"is--active\"],\"outline\"]],[[\"default\"],[[[[1,\"\\n              \"],[10,1],[14,0,\"u--text--base\"],[12],[1,[28,[35,1],[\"media_library.labels.manage.sorting.tagged_count\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"isLabelTaggedCountSorting\"]],[[[1,\"                \"],[10,1],[14,0,\"o--btnDrop__value\"],[12],[1,\"\\n\"],[41,[30,0,[\"isLabelSortingAsc\"]],[[[1,\"                    (\"],[1,[28,[35,1],[\"media_library.labels.manage.sorting.least_to_most\"],null]],[1,\")\\n\"]],[]],[[[1,\"                    (\"],[1,[28,[35,1],[\"media_library.labels.manage.sorting.most_to_least\"],null]],[1,\")\\n\"]],[]]],[1,\"                \"],[13],[1,\"\\n\"]],[]],null],[1,\"              \"],[1,[28,[35,4],[\"caret-down\"],[[\"class\"],[\"o--icon o--btnDrop__icon\"]]]],[1,\"\\n              \"],[8,[39,5],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@position\",\"@target\"],[true,true,\".eLB--labelSortUsage--drop\",\"bottom left\",\".eLB--labelSortUsage--toggle\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,0],[14,0,\"o--dropWrapper--sm eLB--labelSortUsage--drop\"],[12],[1,\"\\n                  \"],[10,0],[14,0,\"o--dropBody--scroll\"],[12],[1,\"\\n                    \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n                      \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n                        \"],[8,[39,2],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[29,[\"o--dropBody__link u--ellipsis \",[52,[30,0,[\"isLabelTaggedCountDesc\"]],\"is--active\"]]],[28,[37,6],[[30,0,[\"setSort\"]],\"taggedCount\",\"desc\"],null],[28,[37,1],[\"media_library.labels.manage.sorting.most_to_least\"],null],\"unstyled\"]],null],[1,\"\\n                      \"],[13],[1,\"\\n                      \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n                        \"],[8,[39,2],null,[[\"@class\",\"@onClick\",\"@text\",\"@variant\"],[[29,[\"o--dropBody__link u--ellipsis \",[52,[30,0,[\"isLabelTaggedCountAsc\"]],\"is--active\"]]],[28,[37,6],[[30,0,[\"setSort\"]],\"taggedCount\",\"asc\"],null],[28,[37,1],[\"media_library.labels.manage.sorting.least_to_most\"],null],\"unstyled\"]],null],[1,\"\\n                      \"],[13],[1,\"\\n                    \"],[13],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n        \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--formWrapper u--m__b__0\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"o--inputAction u--p__r__xs\"],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"search\"],[[\"class\"],[\"o--icon o--inputAction__icon--left\"]]]],[1,\"\\n              \"],[8,[39,7],[[24,0,\"o--inputAction__input u--p__tb__sm qa--mediaLib_manageLabel_search\"],[16,\"placeholder\",[28,[37,1],[\"media_items.labels.search_labels\"],null]]],[[\"@type\",\"@value\"],[\"search\",[30,0,[\"labelSearchString\"]]]],null],[1,\"\\n\"],[41,[30,0,[\"isSearchingLabels\"]],[[[1,\"                \"],[11,1],[4,[38,8],[\"click\",[30,0,[\"clearLabelSearch\"]]],null],[12],[1,\"\\n                  \"],[1,[28,[35,4],[\"close\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--fadeIn--right\"]]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],null],[1,\"            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n    \"],[10,\"hr\"],[14,0,\"u--m__0\"],[12],[13],[1,\"\\n\\n\"],[1,\"\\n    \"],[8,[30,2,[\"card-body\"]],[[24,0,\"has--scroll u--p__0 eLB--manage__scrollContainer\"],[4,[38,9],null,null]],null,[[\"default\"],[[[[1,\"\\n\\n      \"],[10,0],[14,0,\"u--p__lr__lg u--m__tb__md\"],[12],[1,\"\\n\\n\"],[1,\"        \"],[10,0],[14,0,\"o--formWrapper\"],[12],[1,\"\\n          \"],[10,0],[14,0,\"o--inputAction--light u--p__l\"],[12],[1,\"\\n            \"],[8,[39,7],[[24,0,\"o--inputAction__input qa--mediaLib_labelAdd_inputbx\"],[16,\"placeholder\",[28,[37,1],[\"media_items.labels.add_new_label\"],null]]],[[\"@enter\",\"@type\",\"@value\"],[[30,0,[\"addNewLabel\"]],\"text\",[30,0,[\"newLabel\"]]]],null],[1,\"\\n            \"],[11,1],[4,[38,8],[\"click\",[30,0,[\"addNewLabel\"]]],null],[12],[1,\"\\n              \"],[1,[28,[35,4],[\"add-circle\"],[[\"class\"],[\"o--icon o--inputAction__icon--right u--text--hl u--text--lg qa--mediaLib_labelAdd_btn\"]]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[42,[28,[37,11],[[28,[37,11],[[30,0,[\"filteredSortedLabels\"]]],null]],null],null,[[[1,\"          \"],[10,0],[14,0,\"cLB--filter__item\"],[12],[1,\"\\n            \"],[10,0],[14,0,\"cLB--label cLB--label--noPointer u--ellipsis\"],[12],[1,\"\\n              \"],[10,1],[12],[1,[30,3,[\"canonicalTagName\"]]],[13],[1,\"\\n              \"],[10,1],[14,0,\"cLB--label__counter has--icon\"],[12],[1,[30,3,[\"taggedCount\"]]],[13],[1,\"\\n              \"],[11,1],[4,[38,8],[\"click\",[28,[37,12],[[30,0,[\"deleteLabel\"]],[30,3]],null]],null],[12],[1,\"\\n                \"],[1,[28,[35,4],[\"trash\"],[[\"class\"],[\"o--icon--sm cLB--label__icon--delete qa--mediaLib_labelDel_btn\"]]]],[1,\"\\n              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[3]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n\"],[1,\"    \"],[8,[30,2,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,2],[[24,0,\"u--float--right qa--mediaLib_labelDone_btn\"]],[[\"@onClick\",\"@text\",\"@variant\"],[[30,1],[28,[37,1],[\"shared_words.done\"],null],\"outline\"]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[]]]]],[1,\"\\n\"]],[2]]]]]],[\"@closeManageLabelsModal\",\"modal\",\"filteredSortedLabel\"],false,[\"shared/modal\",\"t\",\"shared/ui/button\",\"if\",\"svg-jar\",\"shared/ui/ember-drop\",\"fn\",\"input\",\"on\",\"perfect-scroll\",\"each\",\"-track-array\",\"perform\"]]",
    "moduleName": "media/components/media/manage-labels.hbs",
    "isStrictMode": false
  });
  let ManageLabelsComponent = _exports.default = (_dec = (0, _computed.sort)('args.labels', 'labelSortDefinition'), (_class = class ManageLabelsComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "dialogManager", _descriptor, this);
      _initializerDefineProperty(this, "intl", _descriptor2, this);
      _initializerDefineProperty(this, "newLabel", _descriptor3, this);
      _initializerDefineProperty(this, "labelSortProperty", _descriptor4, this);
      _initializerDefineProperty(this, "labelSortPropertyDir", _descriptor5, this);
      _initializerDefineProperty(this, "labelSearchString", _descriptor6, this);
      _initializerDefineProperty(this, "sortedLabels", _descriptor7, this);
      _defineProperty(this, "deleteLabel", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (label) {
          if (label.taggedCount) {
            const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_library.labels.manage.delete_header'), {
              description: this.intl.t('media_library.labels.manage.delete_message', {
                label_name: label.tagName
              }),
              confirmButton: this.intl.t('shared_words.delete')
            });
            if (!didConfirm) {
              return;
            }
          }
          label.destroyRecord();
        }
      }), null, "deleteLabel", null));
      this.newLabel = null;
      this.labelSortProperty = 'taggedCount';
      this.labelSortPropertyDir = 'desc';
    }
    get filteredSortedLabels() {
      return (0, _utils.isEmpty)(this.labelSearchString) ? this.sortedLabels : (0, _filterByFields.default)(this.sortedLabels, ['tagName'], this.labelSearchString);
    }
    get isLabelNameAsc() {
      return this.isLabelNameSorting && this.isLabelSortingAsc;
    }
    get isLabelNameDesc() {
      return this.isLabelNameSorting && this.isLabelSortingDesc;
    }
    get isLabelNameSorting() {
      return this.labelSortProperty === 'canonicalTagName';
    }
    get isLabelSortingAsc() {
      return this.labelSortPropertyDir === 'asc';
    }
    get isLabelSortingDesc() {
      return this.labelSortPropertyDir === 'desc';
    }
    get isLabelTaggedCountAsc() {
      return this.isLabelTaggedCountSorting && this.isLabelSortingAsc;
    }
    get isLabelTaggedCountDesc() {
      return this.isLabelTaggedCountSorting && this.isLabelSortingDesc;
    }
    get isLabelTaggedCountSorting() {
      return this.labelSortProperty === 'taggedCount';
    }
    get isSearchingLabels() {
      return !(0, _utils.isEmpty)(this.labelSearchString);
    }
    get labelCount() {
      if (!this.args.labels) {
        return 0;
      }
      return this.args.labels.length;
    }
    get labelSortDefinition() {
      return [this.labelSortProperty + ':' + this.labelSortPropertyDir];
    }
    addNewLabel() {
      if (typeof this.newLabel === 'string' && !(0, _utils.isEmpty)(this.newLabel)) {
        this.args.addNewLabel(this.newLabel);
      } else {
        this.newLabel = null;
      }
    }
    clearLabelSearch() {
      this.labelSearchString = undefined;
    }
    setSort(property, direction) {
      this.labelSortProperty = property;
      this.labelSortPropertyDir = direction;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "newLabel", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "labelSortProperty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "labelSortPropertyDir", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "labelSearchString", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "sortedLabels", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "addNewLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearLabelSearch", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearLabelSearch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSort", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSort"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ManageLabelsComponent);
});